import { render, staticRenderFns } from "./FileInputWrapper.vue?vue&type=template&id=45ce98ba&scoped=true&"
import script from "./FileInputWrapper.vue?vue&type=script&lang=js&"
export * from "./FileInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FileInputWrapper.vue?vue&type=style&index=0&id=45ce98ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce98ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
